<div *ngIf="eConsentData">
    <h5 class="mb-4">E-Consent Acknowledgement</h5>
    <div [ngClass]="{'red-bg': !eConsentData.accepted, 'blue-bg': eConsentData.accepted}" class="list-container">
        <div class="row">
            <div class="form-group col-12">
                <label>E-Consent Type</label>
                <h6>Data Usage Consent from Individual</h6>
            </div>
            <div class="form-group col-12">
                <h6>{{eConsentData.econsentTitle}}</h6>
                <h6>{{eConsentData.econsentDesc}}</h6>
            </div>
            <div class="form-group col-12">
                <label>Consent {{ eConsentData.accepted ? 'Accepted' : 'Rejected' }} On: {{eConsentData.econsentDate}} | {{eConsentData.econsentTime}}</label>
            </div>
        </div>
    </div>
</div>

<div *ngIf="noEConsnt">
    <h5 class="text-center my-5 py-5">No Record found.</h5>
</div>